export default function Footer({
  copyrightText = "© 2026 Department of Immigration & Emigration. All Rights Reserved",
  showLinks = true
}) {
  return (
    <div className="footer">
      <p>{copyrightText}</p>
      {/* {showLinks && (
        <div className="footer-links">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/faq">FAQ</a>
          <a href="/contact">Contact Us</a>
        </div> */}
      {/* )} */}

      <style jsx>{`
        .footer {
          text-align: center;
          padding: 2rem;
          color: #6b7280;
          font-size: 0.875rem;
          border-top: 1px solid #e5e7eb;
          margin-top: 2rem;
        }

        .footer p {
          margin: 0 0 1rem 0;
        }

        // .footer-links {
        //   display: flex;
        //   justify-content: center;
        //   gap: 1.5rem;
        //   flex-wrap: wrap;
        // }

        // .footer-links a {
        //   color: #3b82f6;
        //   text-decoration: none;
        //   transition: color 0.2s ease;
        // }

        // .footer-links a:hover {
        //   color: #1d4ed8;
        //   text-decoration: underline;
        // }

        @media (max-width: 768px) {
          .footer {
            padding: 1.5rem 1rem;
          }

          .footer-links {
            flex-direction: column;
            gap: 0.75rem;
          }
        }
      `}</style>
    </div>
  );
}